export default __webpack_public_path__ + "static/media/office1-before2-768w.0181ce36.webp";